import { useState } from "react";
import {
    Box,
    Text,
    Link,
    VStack,
    Button,
    CloseIcon,
    Flex
  } from "native-base";
    import { useNavigate } from "react-router-dom";
  import { useLocation } from 'react-router-dom';
import StyledButton from "../../components/Button";

  function PinkUpcycle() {

    const navigate = useNavigate();
    const location = useLocation();
    const [getTheme, setTheme] = useState(null);
    const [getPageData, setPageData] = useState(null);
  
    return (
      <>
        <Flex minH={'100vh'} direction="column" justifyContent={'space-between'}>
        <Box>
          <VStack alignItems="flex-start" space={4} px={"4"} paddingTop={'4'}>
              <Button onPress={() => navigate(-1)} variant={'unstyled'}><CloseIcon color={'black'} size={"5"}/></Button>
          </VStack>
          <VStack alignItems={"center"} marginBottom={"4"} px={4} space={'6'}>
            <Text color={""} fontFamily={'Unna'}  fontSize={'36px'} letterSpacing={'0.46px'} >Upcycle</Text>
          </VStack>
          <VStack alignItems={"left"} px={4} space={'4'}>
            <Text color={''} fontSize={'12px'} fontFamily={'Unna'}  >
            While this vest was upcycled into the vest you now have in your closet, if something happens to your vest that is irreperable, you can turn it into something else again. 
            </Text>
            <Text color={''} fontSize={'12px'} fontFamily={'Unna'}  >
            Through our partner, Tilli, you can work with their trusted tailors to reimagine the vest into something new so it doesn’t go to waste. 
            </Text>
            <Text color={''} fontSize={'12px'} fontFamily={'Unna'}  >
            Click on the button below to make an appointment. 
            </Text>
            <Link href="https://tilli.fr/reserver-votre-couturier-a-domicile/" width={'full'}>
               <StyledButton
               fontSize={'20px'}
               fontFamily={'Unna'} 
              text={'UPCYCLE NOW'}
              backgroundColor={'#EEA3AC'}
             textColor="black"
            borderColor="transparent"
            width="100%"
            height="54px"
           hoverBackgroundColor="#FFFFFF"
           hoverTextColor={'black'}
           hoverBorderColor={'black'}
          />
          </Link>
          </VStack>
          <VStack alignItems={'center'} marginTop={4}>
          {/* <Image
                source={{ uri: getPageData?.images?.primary }}
                alt="Alternate Text"
                size="xl"
                width="full"
                height="411px"
            /> */}
          </VStack>
          </Box>
          </Flex>
          </>
    );
  }
  
  export default PinkUpcycle;
  